import { api } from "../api"

export const GetServiceEntities = (callBack) => {
    api.get('/api/BMGDadosMestres/entidadesservicos', res => callBack(res.data));
}